/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Faq_8_QInputs */

const en_vc_faq_8_q = /** @type {(inputs: Vc_Faq_8_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does VectorCraft have a Chinese interface?`)
};

const zh_vc_faq_8_q = /** @type {(inputs: Vc_Faq_8_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VectorCraft 有中文界面吗？`)
};

/**
* | output |
* | --- |
* | "Does VectorCraft have a Chinese interface?" |
*
* @param {Vc_Faq_8_QInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_faq_8_q = /** @type {((inputs?: Vc_Faq_8_QInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Faq_8_QInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_faq_8_q(inputs)
	return zh_vc_faq_8_q(inputs)
});
export { vc_faq_8_q as "vc.faq.8.q" }